module.exports = __webpack_public_path__ + "img/picture_viptc04.601a9eeb.png";